import type { SVGProps } from "react";
import * as React from "react";

const SvgDownloadCloud = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#download-cloud_svg__a)">
      <path
        fill="currentColor"
        d="M8.707 16.293a1 1 0 0 0-1.414 1.414zM12 21l-.707.707a1 1 0 0 0 1.414 0zm4.707-3.293a1 1 0 0 0-1.414-1.414zM13 12a1 1 0 1 0-2 0zm7.305 5.272a1 1 0 1 0 1.15 1.636zM18 9v1zm-1.26 0-.969.249a1 1 0 0 0 .969.751zM2.251 16.953a1 1 0 1 0 1.498-1.326zm5.042.754 4 4 1.414-1.414-4-4zm5.414 4 4-4-1.414-1.414-4 4zM11 12v9h2v-9zm10.455 6.908a6 6 0 0 0 2.234-2.989l-1.895-.64a4 4 0 0 1-1.49 1.993zm2.234-2.989a6 6 0 0 0 .035-3.731l-1.907.604a4 4 0 0 1-.023 2.487zm.035-3.731a6 6 0 0 0-2.177-3.03l-1.181 1.614a4 4 0 0 1 1.451 2.02zm-2.177-3.03A6 6 0 0 0 17.999 8l.002 2a4 4 0 0 1 2.365.772zM18 8h-1.26v2H18zm-.291.751a9 9 0 0 0-1.852-3.581l-1.526 1.293a7 7 0 0 1 1.44 2.786zM15.857 5.17a9 9 0 0 0-3.23-2.414l-.808 1.83a7 7 0 0 1 2.512 1.877zm-3.23-2.414a9 9 0 0 0-3.96-.762l.072 1.999a7 7 0 0 1 3.08.592zm-3.96-.762a9 9 0 0 0-3.894 1.044l.937 1.767a7 7 0 0 1 3.03-.812zM4.774 3.038a9 9 0 0 0-3.048 2.64l1.615 1.18a7 7 0 0 1 2.37-2.053zm-3.048 2.64a9 9 0 0 0-1.59 3.705l1.968.357A7 7 0 0 1 3.34 6.858zM.135 9.383a9 9 0 0 0 .188 4.028l1.926-.538a7 7 0 0 1-.146-3.133zm.188 4.028a9 9 0 0 0 1.928 3.542l1.498-1.326a7 7 0 0 1-1.5-2.754z"
      />
    </g>
    <defs>
      <clipPath id="download-cloud_svg__a">
        <path
          fill="#fff"
          d="M0 0h24v24H0z"
        />
      </clipPath>
    </defs>
  </svg>
);
export default SvgDownloadCloud;
